<template>
  <div class="safety-container">
    <!--    :deviceNum="'only'" -->
    <search
      ref="search"
      :formModel="formModel"
      :formButton="formButton"
      :rules="rules"
      :mulTime="mulTime"
      :deviceModelBusiType="1"
      :upLeveName="'safety'"
    ></search>
    <v-main class="safety-content">
      <el-card :header="'本底分析' | translateTo(i18nPath)" class="v-block">
        <template v-for="(e, i) in bg">
          <part
            type="line"
            xAxisType="category"
            option="table,chart"
            :sn="e.sn"
            :key="e.sn"
            :names="e.names"
            :i18n-path="i18nPath"
            :chart-opts="e.opts"
            :table-data="e.tableData"
            :table-cfg="{ tableColumn: e.thead }"
            :header="`${i + 1}、设备 - ${e.sn}${dateRangeText}` | translateTo(i18nPath)"
          ></part>
        </template>
        <p class="overview" v-if="!bg">{{ '暂无数据' | translateTo(i18nPath) }}</p>
      </el-card>
      <el-card :header="'监测分析' | translateTo(i18nPath)" class="v-block">
        <template v-for="(e, i) in monitor">
          <part
            type="line"
            xAxisType="category"
            option="table,chart,description"
            :sn="e.sn"
            :key="e.sn"
            :names="e.names"
            :description="e.description"
            :i18n-path="i18nPath"
            :chart-opts="e.opts"
            :table-data="e.tableData"
            :table-cfg="{ tableColumn: e.thead }"
            :header="`${i + 1}、设备 - ${e.sn}${dateRangeText}` | translateTo(i18nPath)"
          ></part>
        </template>
        <p class="overview" v-if="!monitor">{{ '暂无数据' | translateTo(i18nPath) }}</p>
      </el-card>

      <part
        type="line"
        xAxisType="category"
        option="table"
        :i18n-path="i18nPath"
        :table-data="alarmInfo.data"
        :table-cfg="alarmInfo.tableCfg"
        :header="'设备报警情况' | translateTo(i18nPath)"
      ></part>

      <part
        type="line"
        xAxisType="category"
        option="table,description"
        :description="summary.description"
        :i18n-path="i18nPath"
        :table-data="summary.data"
        :table-cfg="summary.tableCfg"
        :header="'分析总结' | translateTo(i18nPath)"
      ></part>
    </v-main>
  </div>
</template>

<script>
import Search from '@/components/mTable/search';

import VMain from './components/v-main';
import Part from './components/part.vue';
import {
  convertData2,
  // convertSummaryTable,
  // convertAlarmData,
  // convertDiffusionData,
  validParam
  // imgsKeyParser
} from './utils/index';

import { queryBriefReport } from '@/api/dataAnalysis';

import { arrify, awaitTo, dayTime, downFile, formatTimestamp } from '@/utils/utils';
import { isArray } from '@/utils/is';

export default {
  components: {
    Search,
    VMain,
    Part
  },
  data() {
    return {
      i18nPath: 'dataAnalysis',
      formModel: {
        sn: '',
        officeId: [],
        taskId: [],
        deviceModel: '',
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()],
        dataIntervalType: 'm'
      },
      mulTime: {
        dateType: 'datetimerange'
      },
      rules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'change' }],
        deviceModel: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        dataIntervalType: [{ required: true, message: '请选择间隔类型', trigger: 'change' }]
      },
      formButton: [
        {
          text: '查询',
          loading: false,
          event: this.search
        },
        {
          text: '导出',
          code: '010721',
          loading: false,
          event: this.exportData
        }
      ],
      data: {},
      dateRangeText: ''
    };
  },
  computed: {
    monitor() {
      const data = convertData2(this.data.monitor);
      return data;
    },
    bg() {
      const data = convertData2(this.data.bg);
      return data;
    },
    alarmInfo() {
      const alarmInfo = this.data.alarmInfo || {};
      const data = isArray(alarmInfo.dataList) ? alarmInfo.dataList : [];
      const tableColumn = isArray(alarmInfo.dimensions)
        ? alarmInfo.dimensions.map((e, i) => ({ prop: `${i}`, label: e }))
        : [];
      const alarmInfoCfg = {
        data,
        tableCfg: {
          tableColumn
        }
      };

      return alarmInfoCfg;
    },
    summary() {
      const summary = this.data.summary || {};
      const data = isArray(summary.dataList) ? summary.dataList : [];
      const dimensions = (summary.dimensions || []).map((e, i) => ({ prop: `${i}`, label: e }));
      const summaryCfg = {
        data: data,
        description: summary.description,
        tableCfg: {
          tableColumn: dimensions
        }
      };

      return summaryCfg;
    }
  },
  methods: {
    changeDateRangeText() {
      const { rangeDateVal } = this.formModel;
      this.dateRangeText = `（ ${formatTimestamp(rangeDateVal[0])} 至 ${formatTimestamp(
        rangeDateVal[1]
      )}）`;
    },
    async search(e) {
      e.loading = true;
      const { sn, rangeDateVal, officeId, taskId, deviceModel, dataIntervalType } = this.formModel;
      const [err, res] = await awaitTo(
        queryBriefReport(
          validParam({
            sn: arrify(sn || null),
            beginTime: rangeDateVal[0],
            endTime: rangeDateVal[1],
            officeId,
            taskId,
            deviceTypeCode: arrify(deviceModel || null),
            dataIntervalType
          })
        )
      );

      if (err) {
        console.error('[ERROR][safety]', err);
      } else {
        this.data = res.data;
        this.changeDateRangeText();
      }
      e.loading = false;
    },
    exportData(e) {
      e.loading = true;
      const { sn, rangeDateVal, officeId, taskId, deviceModel, dataIntervalType } = this.formModel;
      downFile({
        url: '/stat/exportBriefReport',
        method: 'post',
        data: validParam({
          sn: arrify(sn || null),
          beginTime: rangeDateVal[0],
          endTime: rangeDateVal[1],
          officeId,
          taskId,
          deviceTypeCode: arrify(deviceModel || null),
          dataIntervalType
        })
      }).finally(() => {
        e.loading = false;
      });
    },
    getTableCfg() {
      return {
        tableColumn: [
          { prop: 'name', label: '监测项' },
          { prop: 'avg', label: '平均值' },
          { prop: 'max', label: '最大值' },
          { prop: 'min', label: '最小值' }
        ]
      };
    }
  },
  mounted() {
    this.$refs.search.dataIntervalTypeOptions.splice(0, 1);
  }
};
</script>

<style lang="scss">
.safety-container {
  height: 100%;
  .safety-content {
    margin-top: 10px;
    background: $bg-color;

    .overview {
      white-space: pre-line;
    }

    @media screen and (min-width: 769px) {
      height: calc(100% - 120px);
    }

    @media screen and (min-width: 1920px) {
      height: calc(100% - 80px);
    }
  }
  .ws-preline {
    .cell {
      white-space: inherit;
      text-align: left;
    }
  }
}
</style>
